module.exports = __webpack_public_path__ + "static/img/13.5fc89c11.png";